import React from 'react';
import styles from './index.module.scss';
interface TitleProps {
  children: React.ReactNode;
}
const Title: React.FC<TitleProps> = ({ children }) => {
  // 标题组件
  return (
    <>
      <div className={styles.titleContainer}>
        <div className={styles.titleLeft}></div>
        <div className={styles.title}>{children}</div>
        <div className={styles.titleRight}></div>
      </div>
    </>
  );
};

export default Title;
